import { render } from "./TopNavComponent.vue?vue&type=template&id=5ad6633e"
import script from "./TopNavComponent.vue?vue&type=script&lang=js"
export * from "./TopNavComponent.vue?vue&type=script&lang=js"

import "./TopNavComponent.vue?vue&type=style&index=0&id=5ad6633e&lang=scss&coped=true"
script.render = render

export default script